import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';
import { BaseResourceLibraryItemSchema } from './resourceLibraryBaseZodSchemas';

export const ResourceLibraryInternalLinkItemSchema = BaseResourceLibraryItemSchema.extend({
    route: z.string(),
}).describe('ResourceLibraryInternalLinkItemSchema');

// Main schema to validate the entire query response
export const GetResourceLibraryInternalLinkItemListingSchema = z
    .object({
        getResourceLibraryInternalLinkItemListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) =>
                    transformAndFilterValidEdges(ResourceLibraryInternalLinkItemSchema, edges)
                ),
        }),
    })
    .describe('GetResourceLibraryInternalLinkItemListingSchema');
